import { Injectable, inject, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { UserDataService } from './user-data.service';
import { AuthSessionService } from './auth-session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private injector = inject(Injector);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const authSession = this.injector.get(AuthSessionService);
        const hasToken = authSession.hasToken();

        // 401 = token inválido/expirado -> sessão realmente acabou, desloga.
        // 403 = autenticado mas sem permissão para ESTA ação/recurso -> NÃO desloga, apenas avisa.
        if (error.status === 401 && hasToken) {
          const user = this.injector.get(UserDataService);
          const router = this.injector.get(Router);
          const snackBar = this.injector.get(MatSnackBar);
          const translate = this.injector.get(TranslateService);

          user.signOut();

          snackBar.open(translate.instant('MAP.SESSION_EXPIRED'), translate.instant('MAP.CLOSE'), {
            panelClass: 'notification-snackbar',
            verticalPosition: 'top',
          });

          router.navigateByUrl('/login');
        } else if (error.status === 403 && hasToken) {
          const snackBar = this.injector.get(MatSnackBar);
          const translate = this.injector.get(TranslateService);

          snackBar.open(translate.instant('MAP.NO_PERMISSION'), translate.instant('MAP.CLOSE'), {
            panelClass: 'notification-snackbar',
            verticalPosition: 'top',
          });
        }
        return throwError(() => error);
      })
    );
  }
}
